export default __webpack_public_path__ + "static/media/hammer-and-wrench.4116a9d6.png";